import type { Discrepancy } from '@/types/orders';
import { DISCREPANCY_STATUS_LABELS } from '@/types/orders';

interface StatusBadgeProps {readonly status: Discrepancy['status'];}

const STATUS_CONFIG: Record<Discrepancy['status'], {
  bg: string;
  text: string 
}> = {
  open: {
    bg: 'bg-slate-100',
    text: 'text-slate-600',
  },
  pending_supplier_response: {
    bg: 'bg-amber-50',
    text: 'text-amber-700',
  },
  pending_receiver_confirmation: {
    bg: 'bg-slate-100',
    text: 'text-slate-600',
  },
  resolved: {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
  },
  disputed: {
    bg: 'bg-slate-100',
    text: 'text-slate-600',
  },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const {
    bg, text 
  } = STATUS_CONFIG[status];

  return (
    <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${bg} ${text}`}>
      {DISCREPANCY_STATUS_LABELS[status]}
    </span>
  );
}
